(function (angular) {
    /**
     * Directive to scroll the page to an element when a certain condition is true
     */
    angular.module('app').directive('scrollIf', function () {
        return function (scope, element, attributes) {
            setTimeout(function () {
                if (scope.$eval(attributes.scrollIf)) {
                    window.scrollTo(0, element[0].offsetTop - 100);
                }
            });
        }
    });
})(angular);